import React from "react";
import { Outlet, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Sidebar from "../components/sidebar/sidebar";
import "../index.css";

const Layout = () => {
  const navigate = useNavigate();
  // console.log('in Layout, access token', localStorage.getItem("accessToken"))

  useEffect(() => {
    // console.log('in Layout useEffect, access token', localStorage.getItem("accessToken"))
    if (!localStorage.getItem("accessToken")) {
      navigate("/login");
      return;
    }
  }, []);

  return localStorage.getItem("accessToken") ? (
    <>
      <Sidebar />
      <div className="main-layout">
        <Outlet />
      </div>
    </>
  ) : (
    <></>
  );
};

export default Layout;
